import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from './header';
import MenuDrawer from './menuDrawer';
import Preloader from './preloader';
import CustomCursor from './customCursor';
import Contact from './contact';
import Footer from './footer';
import usePortfolioMotion from '../hooks/usePortfolioMotion';
import useSectionNavigation from '../hooks/useSectionNavigation';
import '../styles/shared.css';

export default function SiteLayout() {
  const root = useRef(null);
  const trigger = useRef(null);
  const [ready, setReady] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const navigateToSection = useSectionNavigation();
  const finishLoading = useCallback(() => setReady(true), []);
  const closeMenu = useCallback((destination) => {
    setMenuOpen(false);
    if (!destination) return;
    if (destination.startsWith('#')) navigateToSection(destination);
    else {
      const [pathname, hash] = destination.split('#');
      const destinationPath = pathname || location.pathname;
      if (destinationPath === location.pathname) {
        navigateToSection(hash ? `#${hash}` : '#top');
      } else navigate(destination);
    }
  }, [navigate, location.pathname, navigateToSection]);
  usePortfolioMotion(root, ready, location.pathname);
  useEffect(() => {
    document.title = `${location.pathname === '/projects' ? 'Projects' : location.pathname === '/about' ? 'About' : 'Portfolio'} — Zeina Tamer`;
    if (!ready) return undefined;
    const frame = requestAnimationFrame(() => {
      if (location.hash) navigateToSection(location.hash);
      else window.scrollTo({ top: 0, behavior: 'instant' });
    });
    return () => cancelAnimationFrame(frame);
  }, [location.pathname, location.hash, ready, navigateToSection]);
  return <div className="site-layout" id="top" ref={root} data-ready={ready}>
    {!ready && <Preloader onComplete={finishLoading} />}
    {ready && <CustomCursor />}
    <Header menuOpen={menuOpen} onOpen={() => setMenuOpen(true)} triggerRef={trigger} inert={!ready || menuOpen} />
    {menuOpen && <MenuDrawer onClose={closeMenu} triggerRef={trigger} />}
    <div inert={!ready || menuOpen ? true : undefined}>
      <main tabIndex="-1"><Outlet context={{ ready }} /><Contact /></main>
      <Footer />
    </div>
  </div>;
}
